class EmployeeNameController {
  constructor() {
  }

  $onInit() {
    this.title = this.getTitle();
  }

  getTitle() {
    let title = this.name;
    if (process.env.isDev) {
      title = this.enrollment;
    }
    return title;
  }
}

export default EmployeeNameController;



// WEBPACK FOOTER //
// ./client/app/components/employeeName/employeeName.controller.js